import axios from "axios";
// 转换时间格式
export function timeValidate(date, type) {
    const time = date ? new Date(date) : new Date();
    const yyyy = time.getFullYear();
    const MM = (time.getMonth() + 1).toString().padStart(2, 0);
    const dd = time.getDate().toString().padStart(2, "0");
    const hh = time.getHours().toString().padStart(2, "0");
    const mm = time.getMinutes().toString().padStart(2, "0");
    const ss = time.getSeconds().toString().padStart(2, "0");
    if (type == "ymd") {
        return `${yyyy}-${MM}-${dd}`;
    }
    if (type == "md") {
        return `${MM}.${dd}`;
    }
    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
}
// 讲课邀约接口
export function submitForm(url, data = {}, fun) {
    axios.post(`/api${url}`, data, {}).then((res) => {
        fun(res.data);
    });
}